// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ze","subtitle":"Ae","contentWrap":"Be","imgWrap":"Ce","heading":"De","copy":"Ee"};